import repository from '@/repositories/Repository'

const resource = '/api/accounts'

export default {
  get(userId) {
    return repository.mouse.get(`${resource}/${userId}`).then(r => r.data)
  },
  getOne(userId, company) {
    return repository.mouse
      .get(`${resource}/${userId}/${company}`)
      .then(r => r.data)
  },
}
